import { render, staticRenderFns } from "./MsInfo.vue?vue&type=template&id=1b7550ab&"
import script from "./MsInfo.vue?vue&type=script&lang=js&"
export * from "./MsInfo.vue?vue&type=script&lang=js&"
import style0 from "./MsInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports